import { render, staticRenderFns } from "./ResetExpiredPassword.vue?vue&type=template&id=2f8081be"
import script from "./ResetExpiredPassword.vue?vue&type=script&lang=js"
export * from "./ResetExpiredPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports